import 'core-js/features/object';

import { platform } from './platform';
// @ts-ignore
export const track = (event, properties): void => {
  const amendedProperties = {
    platform,
    product: process.env.SEGMENT_PRODUCT || process.env.REACT_APP_SEGMENT_PRODUCT,
    ...properties,
  };

  if ((window as any).analytics) {
    (window as any).analytics.track(event, amendedProperties);
  }
};
